import React, { useState, Fragment, useEffect } from 'react';
import cx from 'classnames';
import { Form as FinalForm, Field, FormSpy } from 'react-final-form';
import PropTypes from 'prop-types';

// components
import { ButtonV2, InputFieldV2Adapter } from '@zola/zola-ui';
import MeetingTimeFormFieldSet from 'components/manage/VirtualEvents/MeetingTimeFormFieldSet';
import { FormDropdown, FormInput } from 'components/common/form/FinalFormV2Elements';

// util
import * as Validations from 'components/common/form/commonValidations';
import EventTypes from 'components/manage/events/util/EventTypes';
import { parseStartTime } from '../../../../util/formDataUtil';

import css from './ExistingZoomLinkForm.module.less';
import FormPlaceholder from '../common/FormPlaceholer/FormPlaceholder';

// TODO: add component tests

const ExistingZoomLinkForm = ({
  initialValues,
  onSubmit,
  onValidateLink,
  handleSaveFormState,
  isUpdate,
}) => {
  const [hasValidated, setHasValidated] = useState(false);
  const [meeting, setMeeting] = useState();

  useEffect(() => {
    if (initialValues && initialValues.zoomLink) {
      setHasValidated(true);
    }
  }, [setHasValidated, initialValues]);

  const handleValidateLink = values => {
    const { zoomLink } = values;
    return onValidateLink(zoomLink)
      .then(meetingView => {
        setHasValidated(true);
        const { name = null, type = null } = initialValues;
        const {
          start_time: zoomStartTime,
          timezone,
          meeting_id: zoomMeetingId,
          topic = name,
        } = meetingView;
        const { date, startTime } = parseStartTime(zoomStartTime, timezone);
        setMeeting({
          date,
          startTime,
          timezone,
          zoomLink,
          zoomMeetingId,
          eventId: initialValues.eventId,
          name: topic,
          type,
        });
      })
      .catch(() => {
        return { zoomLink: 'Invalid Zoom Link' };
      });
  };

  return (
    <div className={cx(css.container, `createZoomeEventForm`)} data-testid="existing-zoomlink-form">
      <FinalForm
        initialValues={initialValues}
        onSubmit={handleValidateLink}
        // debug={console.log}
        render={({ handleSubmit, submitting }) => {
          return (
            <form onSubmit={handleSubmit}>
              <div className={css.zoomLinkFields}>
                <Field
                  name="zoomLink"
                  validate={Validations.REQUIRED}
                  render={fieldProps => (
                    <InputFieldV2Adapter
                      className={cx(css.zoomLinkInput, {
                        [css.marginRight]: !hasValidated,
                      })}
                      label="Your Zoom Event Link"
                      helperText="Must be a scheduled, one-time meeting (not recurring)."
                      disabled={hasValidated && !isUpdate}
                      type="text"
                      placeholder="https://zoom.us..."
                      input={fieldProps.input}
                      meta={fieldProps.meta}
                    />
                  )}
                />
                {!hasValidated && (
                  <ButtonV2 type="submit" disabled={submitting} className={css.validateLinkButton}>
                    Add &amp; Review
                  </ButtonV2>
                )}
                <FormSpy
                  subscription={{ dirtySinceLastSubmit: true, dirty: true }}
                  onChange={() => setHasValidated(false)}
                />
              </div>
            </form>
          );
        }}
      />
      <FinalForm
        initialValues={meeting || initialValues}
        onSubmit={onSubmit}
        // debug={console.log}
        render={({ handleSubmit, submitting, form }) => {
          const showFields = hasValidated;
          const showPlaceholder = !hasValidated && isUpdate;
          return (
            <form onSubmit={handleSubmit}>
              <Field
                name="zoomMeetingId"
                disabled
                render={() => null}
                validate={Validations.REQUIRED}
              />
              <Field name="eventId" disabled render={() => null} />
              {showFields && (
                <Fragment>
                  <div className={css.eventFields}>
                    <FormInput
                      name="name"
                      className={css.marginRight}
                      label="Event Title"
                      placeholder="Our Wedding"
                      maxChars={100}
                      validate={[Validations.REQUIRED, Validations.MAX_LENGTH_100]}
                      disabled={!hasValidated}
                    />
                    <FormDropdown
                      name="type"
                      options={EventTypes}
                      label="Event Type"
                      validate={[Validations.REQUIRED]}
                      placeholder="Select..."
                      disabled={!hasValidated}
                    />
                  </div>
                  <MeetingTimeFormFieldSet disabled={!hasValidated} />
                  <ButtonV2
                    type="submit"
                    className={css.button}
                    disabled={submitting || !hasValidated}
                  >
                    Save Event Details
                  </ButtonV2>
                </Fragment>
              )}
              {showPlaceholder && <FormPlaceholder />}
              <FormSpy
                subscription={{ values: true }}
                onChange={formState => {
                  if (typeof handleSaveFormState === 'function') {
                    handleSaveFormState(formState.values);
                  }
                }}
              />
            </form>
          );
        }}
      />
    </div>
  );
};

ExistingZoomLinkForm.defaultProps = {
  initialValues: {},
};

ExistingZoomLinkForm.propTypes = {
  onValidateLink: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleSaveFormState: PropTypes.func,
  isUpdate: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  onUpdateSuccess: PropTypes.func, // used in ownProps
  initialValues: PropTypes.shape({}),
};

export default ExistingZoomLinkForm;



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ExistingZoomLinkForm/ExistingZoomLinkForm.jsx